export default {
    AttachmentRefreshDownloadToken: {
        datapoint: {
            name: 'AttachmentRefreshDownloadToken',
            customData: (totalTries: number): [any] => [totalTries],
        },
    },
};
